import { useParams } from 'react-router-dom';
import { useContent } from '../context/ContentContext';
import type { CmsPageType } from '../types/cmsPages';

export function usePublishedPage(type: CmsPageType) {
  const { slug } = useParams<{ slug: string }>();
  const { pages, loading } = useContent();
  const page = pages.find(item => item.slug === slug && item.type === type) ?? null;
  return { page, loading, notFound: !loading && !page };
}
